import React, { Component } from 'react';
import './styles.css';
import { Grid, Tooltip } from '@material-ui/core';

class ButtonBoxIcon extends Component {

    //Funcion que el estado del boton
    pinchar = () => {
        const { group, value, id, indice } = this.props;

        this.props.Seleccion(value, id, group, indice);
    };

    render() {
        //Constantes recibidas mediante props de los componentes internos de Fenomene Selection
        const { value } = this.props;
        // const { icon } = this.props;
        //console.log(`A button: titulo ${title}, value ${value}, id ${id}`);
        return (
            // console.log(`Desde ButtonBoxIcon ${title} y estado ${estadoClick} y posicion ${value}`),
            //Propiedades del boton usado en los componentes internos
            <Grid>
                <Grid>
                    <Tooltip title={value}>
                        <button
                            className={this.props.classSelected}
                            // className="pinchado"
                            name="ButtonBox"
                            onClick={this.pinchar}

                        >
                            <Grid className="btnIntern" >
                                {/* <Grid className="btnIcon">
                                    <img src={icon} alt=""/>
                                </Grid> */}
                                <Grid >
                                    {value}
                                </Grid>
                            </Grid>
                        </button>
                    </Tooltip>
                </Grid>
            </Grid>
        )
    }
}


export default ButtonBoxIcon;